import {
  SELECT_TILE,
  SELECT_VIEW_ID,
  COMPLETE_HYDRATION, UPDATE_ACTIVITY
} from "../actions/actions";



const initialState = {
  tile: null,
  id: null,
  isHydrated: false,
  lastActivity: null
};

export const selection = (state=initialState, action) => {
  switch (action.type) {
    case SELECT_TILE:
      return {
        ...state,
        tile: action.tile,
        error: action.error,
        id: null
      };
    case SELECT_VIEW_ID:
      return {
        ...state,
        id: action.id,
      };
    case UPDATE_ACTIVITY:
      return {
        ...state,
        lastActivity: action.now,
      };
    case COMPLETE_HYDRATION:
      return {
        ...state,
        isHydrated: true,
      };
    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/reducers/selection.js